"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _emotion = require("emotion");

var _default = function _default() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      scrollbarWidth = _ref.scrollbarSize.scrollbarWidth;

  return /*#__PURE__*/(0, _emotion.css)("&.ReactTable .rt-thead.-header{padding-right:", scrollbarWidth, "px;}&.ReactTable{width:100%;box-sizing:border-box;.rt-tbody{overflow-y:scroll;overflow-x:hidden;}}.-pageJump{border:solid 1px lightgrey;border-radius:5px;}.ReactTable .-pagination_button{cursor:pointer;padding-left:10px;padding-right:10px;color:grey;user-select:none;}.ReactTable .-pagination_button.-current{background:lightgrey;color:#f0f1f6;}");
};

exports["default"] = _default;